import AdminApi from '../services/api';
import swal from 'sweetalert2';
import Loc from "../services/localization";

/* init */

const AdminApiService = new AdminApi()
const LocService = new Loc()

export default{

    props: ['show', 'package'],

    data() {
        return {
            locale: LocService,
            isLoading: false,
            hasError: '',
            packageName: '',
            dateFrom: null,
        };
    },

    watch: {
        show: function(val, oldVal) {
            if(val){
                this.packageName = this.package.name
                this.dateFrom = null
            }
        },
    },

    methods: {
        close() {
            this.reset();
            this.$topnavbar.$emit('closeChooseDateMemebership')
        },
        keymonitor: keymonitor,
        reset:reset,
        buyMembership:buyMembership,
        load: load,
        isMobile() {
            return window.innerWidth <= 850; // Adjust the breakpoint as needed
        },
        getClassMobile(){
            if(this.isMobile()){
                return 'modal--small'
            }else {
                return 'modal--medium'
            }
        },
        modalStyle(){
            if(this.isMobile()){
                return 'color: white; background-color: black;'
            }else {
                return ''
            }
        },
        mainDivStyle(){
            if(this.isMobile()){
                return 'background-color: #1C242D; color: #ffffff;'
            }else {
                return 'background-color: #1C242D; color: #ffffff;'
            }
        },
        tableStyle(){
            if(this.isMobile()){
                return 'height: 400px !important; overflow: auto; padding: 15px;';
            }
            return 'height: 600px !important; overflow: auto; padding: 15px;';
        }
    }
}

function keymonitor(event) {
    if (event.key === 'Enter') {
        this.load();
    }
}

function load() {

}

function reset(){
    this.packageName = ''
    this.dateFrom = null

}

function buyMembership(){
    if(this.dateFrom == null ){
        swal(LocService.t("label_error"), LocService.t("label_please_select_date"), 'error')
        return
    }
    let dateToSend = this.$moment(this.dateFrom).format('DD-MM-YYYY')
    let _self = this;
    AdminApiService.buyMembershipsPackage(this.package.id, dateToSend)
        .then((response) => {
            swal(LocService.t('label_success'), LocService.t('label_success_bought_membership'), 'success')
            _self.close();
        })
        .catch(error => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}



// WEBPACK FOOTER //
// ./src/modals/ChooseDateForMemberShip.js